import React from 'react'
import { LoaderWrapper } from './index.styled'

const CircleLoader = React.memo(({ className, ...rest }) => {
	return (
		<LoaderWrapper className={className} {...rest}>
			<div />
			<div />
			<div />
		</LoaderWrapper>
	)
})


CircleLoader.displayName = 'CircleLoader'
export default CircleLoader
